import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

function LogosSlider() {
  const swipers = document.querySelectorAll('.logos__slider[data-animated="true"]');

  if (!swipers.length) {
    return;
  }

  swipers.forEach((swiperEl) => {
    new Swiper(swiperEl, {
      modules: [Autoplay],
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,
      speed: 4500,
      allowTouchMove: false,
      centeredSlides: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        768: {
          spaceBetween: 32,
        },
        1024: {
          spaceBetween: 40,
        },
      },
    });
  });
}

export default LogosSlider;
